var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{attrs:{"execute":_vm.execute,"sitekey":_vm.siteKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }